/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdminLoginPayload } from './AdminLoginPayload';
import {
    AdminLoginPayloadFromJSON,
    AdminLoginPayloadFromJSONTyped,
    AdminLoginPayloadToJSON,
} from './AdminLoginPayload';
import type { ManagerLoginPayload } from './ManagerLoginPayload';
import {
    ManagerLoginPayloadFromJSON,
    ManagerLoginPayloadFromJSONTyped,
    ManagerLoginPayloadToJSON,
} from './ManagerLoginPayload';
import type { PatientLoginPayload } from './PatientLoginPayload';
import {
    PatientLoginPayloadFromJSON,
    PatientLoginPayloadFromJSONTyped,
    PatientLoginPayloadToJSON,
} from './PatientLoginPayload';
import type { PhysicianLoginPayload } from './PhysicianLoginPayload';
import {
    PhysicianLoginPayloadFromJSON,
    PhysicianLoginPayloadFromJSONTyped,
    PhysicianLoginPayloadToJSON,
} from './PhysicianLoginPayload';

/**
 * 
 * @export
 * @interface UserLoginPayload
 */
export interface UserLoginPayload {
    /**
     * 
     * @type {string}
     * @memberof UserLoginPayload
     */
    role: UserLoginPayloadRoleEnum;
    /**
     * 
     * @type {PatientLoginPayload}
     * @memberof UserLoginPayload
     */
    patient?: PatientLoginPayload;
    /**
     * 
     * @type {AdminLoginPayload}
     * @memberof UserLoginPayload
     */
    admin?: AdminLoginPayload;
    /**
     * 
     * @type {PhysicianLoginPayload}
     * @memberof UserLoginPayload
     */
    physician?: PhysicianLoginPayload;
    /**
     * 
     * @type {ManagerLoginPayload}
     * @memberof UserLoginPayload
     */
    manager?: ManagerLoginPayload;
}


/**
 * @export
 */
export const UserLoginPayloadRoleEnum = {
    Patient: 'patient',
    Admin: 'admin',
    Physician: 'physician',
    Manager: 'manager'
} as const;
export type UserLoginPayloadRoleEnum = typeof UserLoginPayloadRoleEnum[keyof typeof UserLoginPayloadRoleEnum];


/**
 * Check if a given object implements the UserLoginPayload interface.
 */
export function instanceOfUserLoginPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function UserLoginPayloadFromJSON(json: any): UserLoginPayload {
    return UserLoginPayloadFromJSONTyped(json, false);
}

export function UserLoginPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLoginPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': json['role'],
        'patient': !exists(json, 'patient') ? undefined : PatientLoginPayloadFromJSON(json['patient']),
        'admin': !exists(json, 'admin') ? undefined : AdminLoginPayloadFromJSON(json['admin']),
        'physician': !exists(json, 'physician') ? undefined : PhysicianLoginPayloadFromJSON(json['physician']),
        'manager': !exists(json, 'manager') ? undefined : ManagerLoginPayloadFromJSON(json['manager']),
    };
}

export function UserLoginPayloadToJSON(value?: UserLoginPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': value.role,
        'patient': PatientLoginPayloadToJSON(value.patient),
        'admin': AdminLoginPayloadToJSON(value.admin),
        'physician': PhysicianLoginPayloadToJSON(value.physician),
        'manager': ManagerLoginPayloadToJSON(value.manager),
    };
}

